export const CREDIT_CARD_NUMBER = '9999 9999 9999 9999';
export const CREDIT_CARD_VALIDITY = '99/9999';
export const CREDIT_CARD_CVV = '9999';
export const CPF_CNPJ = '99999999999999';
export const FULL_DATE = '99/99/9999';
export const HOUR_MINUTE = '99:99';
